// extracted by mini-css-extract-plugin
module.exports = {"container":"user-grid_container__1000O","card":"user-grid_card__1koKW","two-columns":"user-grid_two-columns__U2Tee"};